export enum TechnologyClassification {
  MODALITY = 'modality',
  DRUG_CLASS = 'drug_class',
  TECHNOLOGY = 'technology',
  DOMAIN = 'domain',
  MECHANISM = 'mechanism',
  PLATFORM = 'platform',
  APPLICATION = 'application',
}

export interface Technology {
  id: string;
  name: string;
  classification?: TechnologyClassification;
  content_archive_url?: string;
  description?: string;
  summary_description?: string;
  metadata_description?: string;
  attribution_statement?: string;
  completion_score?: number;
  date_updated?: string;
  parent_technologies?: Array<{ id: string; name: string }>;
  child_technologies?: Array<{ id: string; name: string }>;
  companies?: Array<{ id: string; name: string }>;
}

export interface TechnologyCreate {
  id?: string;
  name: string;
  classification?: TechnologyClassification;
  content_archive_url?: string;
  description?: string;
  summary_description?: string;
  metadata_description?: string;
  attribution_statement?: string;
  completion_score?: number;
  parent_technology_ids?: string[];
  child_technology_ids?: string[];
}

export interface TechnologyUpdate {
  name?: string;
  classification?: TechnologyClassification;
  content_archive_url?: string;
  description?: string;
  summary_description?: string;
  metadata_description?: string;
  attribution_statement?: string;
  completion_score?: number;
  parent_technology_ids?: string[];
  child_technology_ids?: string[];
}

export interface TechnologyListItem {
  id: string;
  name: string;
  classification?: string;
  summary_description?: string;
}
